<template>
    <div class="garanties-list">
        <div class="clients__title">
            Importer des garanties
        </div>

        <template v-if="isLoading">
            <Preloader />
        </template>
        <template v-else>
          <div class="garanties-filter">
            <div class="garanties-filter--wrap">
              <div class="garanties-filter__fields">
                <div class="garanties-filter__buttons">
                  <button class="garanties-filter__buttons--button template" @click="uploadGarantiesImportTemplate">Télécharger le modèle</button>
                </div>

                <ImportGuaranteesLoadFileInput
                  v-model="document.file"
                  :options="document.options"
                  :allowedFileExtensions="document.allowedFileExtensions"
                  :apiUrl="importApiUrl"
                  :api-url="importApiUrl"
                  @uploaded="importDone"
                />

                  <GarantieResponseModal v-show="importResponseModal" @close="closeImportModal" :result="importResult" :is-dental="isDentalRepresentative" />

              </div>
            </div>
          </div>
        </template>
    </div>
</template>

<script>
    import Preloader from '@/components/Preloader';
    import ImportGuaranteesLoadFileInput from "./ImportGuaranteesLoadFileInput";
    import GarantieResponseModal from "../GarantieResponseModal";

    export default {
        name: "GarantiesImport",
        components: {GarantieResponseModal, ImportGuaranteesLoadFileInput, Preloader},
        mixins: [],
        data() {
            return {
              importResponseModal: false,
              importResult: {},
              document: {
                type: 'IMPORT_GUARANTEES',
                title: '',
                file: null,
                options: {name: 'Choisir un document', placeholder: true, currentFile: false, hash: null},
                allowedFileExtensions: `application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`
              },
              isLoading: false,
            }
        },
        computed: {
          isDentalRepresentative() {
            return this.$store.getters.isDental;
          },
          importApiUrl() {
            return this.isDentalRepresentative ? 'dental/import' : 'guarantees/import/list';
          }
        },
        watch: {},
        methods: {
          uploadGarantiesImportTemplate() {
            let url = this.isDentalRepresentative ? 'dental/export/template' : 'guarantees/export/template';
            window.location = this.getApiAuthUrl(url);
          },
            importDone(data) {
                this.importResult = data;
                this.importResponseModal = true;
            },
            closeImportModal() {
              this.importResponseModal = false;
            }
        },
        mounted() {}

    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/Import/GarantiesImport.vue